export default {
  updateDealers(state, data) {
    state.dealers = data;
  },

  /**
   *
   * @param state
   * @param value
   */
  addEmptyDealer(state, value) {
    state.dealers.unshift(value);
  },

  updateNotApprovedDealers(state, data) {
    state.not_approved_dealers = data;
  },

  updateNotApprovedDealer(state, val) {
    state.not_approved_dealers.splice(val.index, 1);
  },

  updateDealer(state, val) {
    const index = state.dealers.findIndex(item => item.uuid === val.uuid);

    if (index !== -1) {
      state.dealers.splice(index, 1, val);
    }
  },

  updateDeleteId(state, val) {
    state.dealerDelete = val;
  },
}
